export const snapToStage = (value: number): number => {
  const stages = [0, 16.67, 33.33, 50, 66.67, 83.33, 100];
  return stages.reduce((prev, curr) => 
    Math.abs(curr - value) < Math.abs(prev - value) ? curr : prev
  );
};

export const getPersonalityText = (value: number, leftTrait: string, rightTrait: string): string => {
  if (value === 50) return `Balanced between ${leftTrait} and ${rightTrait}`;
  
  let leftPercentage: number;
  let rightPercentage: number;
  
  if (value < 50) {
    const stepsFromMiddle = Math.round((50 - value) / 16.67);
    rightPercentage = 40 - (stepsFromMiddle - 1) * 20;
    leftPercentage = 100 - rightPercentage;
  } else {
    const stepsFromMiddle = Math.round((value - 50) / 16.67);
    leftPercentage = 40 - (stepsFromMiddle - 1) * 20;
    rightPercentage = 100 - leftPercentage;
  }

  return `${Math.max(leftPercentage, rightPercentage)}% ${value < 50 ? leftTrait : rightTrait}`;
};

export const getPromptPersonalityText = (value: number, leftTrait: string, rightTrait: string): string => {
  if (value === 50) return `Balanced between ${leftTrait} and ${rightTrait}`;
  
  let leftPercentage: number;
  let rightPercentage: number;
  
  if (value < 50) {
    const stepsFromMiddle = Math.round((50 - value) / 16.67);
    rightPercentage = 40 - (stepsFromMiddle - 1) * 20;
    leftPercentage = 100 - rightPercentage;
  } else {
    const stepsFromMiddle = Math.round((value - 50) / 16.67);
    leftPercentage = 40 - (stepsFromMiddle - 1) * 20;
    rightPercentage = 100 - leftPercentage;
  }

  return `${Math.max(leftPercentage, rightPercentage)}% ${value < 50 ? leftTrait : rightTrait} and ${Math.min(leftPercentage, rightPercentage)}% ${value < 50 ? rightTrait : leftTrait}`;
};

export const validateHexColor = (color: string): boolean => {
  return /^#[0-9A-Fa-f]{6}$/.test(color);
};

export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};